module.exports = __webpack_public_path__ + "media/components/assets/icons/lesson_ok-99b2822d1b34e89e4bce10a5afa9e13f.svg";